import { z } from "zod";

/**
 * HCA Moravia — klient portal + PWA (Sprint 57, §12 nice-to-have).
 */

const uuidMsg = "Neplatné UUID";

export const createKlientLoginSchema = z.object({
  klientId: z.string().uuid(uuidMsg),
  email: z.string().email("Neplatný e-mail").max(255, "E-mail musí být 255 znaků nebo méně"),
});

export const subscribeToPushSchema = z.object({
  endpoint: z.string().url("Neplatný push endpoint URL").max(2000),
  p256dh: z.string().min(1).max(500),
  auth: z.string().min(1).max(500),
});

export const unsubscribePushSchema = z.object({
  endpoint: z.string().url().max(2000),
});

export const updateSubscriptionSchema = z.object({
  stav: z.enum(["none", "premium", "cancelled"]),
});

export type CreateKlientLoginInput = z.infer<typeof createKlientLoginSchema>;
export type SubscribeToPushInput = z.infer<typeof subscribeToPushSchema>;
